import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { ModalDialog } from "components";
import { useOrders } from "hooks";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { color_theme } from "../../color-theme";

interface ModalConfirmAgeProps {
  open: boolean;
  setOpen(value: boolean): void;
  loading: boolean;
  setLoading: any;
  setError: any;
}

const ModalConfirmAge: FC<ModalConfirmAgeProps> = ({
  open,
  setOpen,
  loading,
  setLoading,
  setError,
}) => {
  const { createOrder } = useOrders();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState<boolean>(false);

  const next = async () => {
    // dispatch(shoppingCartActions.cleanShoppingCart());

    // TODO: precisamos criar o pedido AQUI, mas precisamos evitar que o usuario volte pra essa tela (se voltar, ele recria o pedido...
    try {
      setLoading(true);
      setDisabled(true);
      setOpen(false);

      const result = await createOrder();

      if (result.error) {
        setLoading(false);
        setOpen(false);
        setDisabled(false);

        if (result?.statusCode === 400) setError(result?.message);
        else
          setError(
            "erro ao criar seu pedido :c entre em contato com o SAC no menu e resolveremos este problema"
          );
        return;
      }
      navigate("/payment-type");
    } catch (err) {
      setLoading(false);
      setDisabled(false);
      setOpen(false);
      setError(
        "erro ao criar seu pedido :c entre em contato com o SAC no menu e resolveremos este problema"
      );
      console.log("Erro na criação do pedido: ", err);
    }
  };

  return (
    <ModalDialog open={open} setOpen={setOpen}>
      <Box justifyContent="center" alignItems="center" p={4}>
        <Typography fontWeight={600}>
          Confirmo ser maior de idade (+18)
        </Typography>
        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button
            disabled={disabled}
            variant="contained"
            sx={{
              backgroundColor: color_theme.background.black.disabled,
              mr: 1,
            }}
            onClick={() => setOpen(false)}
          >
            Recusar
          </Button>
          <Button disabled={disabled} variant="contained" onClick={next}>
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "confirmar"
            )}
          </Button>
        </Box>
      </Box>
    </ModalDialog>
  );
};
export default ModalConfirmAge;
